import { TFunction } from 'i18next'

import { LanguageResources } from '@/@types/i18next'
import { FileType } from '../models/files'

export function translateFileTypeEnum(
  t: TFunction<[LanguageResources]>,
  fileType: FileType,
): string {
  switch (fileType) {
    case FileType.CLAIMS:
      return t('common:enums.file_type.claims')
    case FileType.ABACO:
      return t('common:enums.file_type.abaco')
    case FileType.LUBRIFICANTS:
      return t('common:enums.file_type.lubrificants')
    case FileType.PRICER:
      return t('common:enums.file_type.pricer')
    case FileType.OTHER:
      return t('common:enums.file_type.other')
    default:
      return fileType
  }
}
